import React from 'react';
import { useTranslation } from 'react-i18next';

import { MediaElement } from 'editor/src/store/design/types';
import { TextOverflowWarning } from 'editor/src/store/editorModules/warnings/types';

import AbstractWarningItem from './AbstractWarningItem';

interface Props {
  warning: TextOverflowWarning;
  element: MediaElement;
  selected: boolean;
}

// GAPI-61892: no fix action on purpose — shortening the text, making it smaller,
// tightening the line spacing or enlarging the frame are all valid answers.
function TextOverflowWarningItem({ warning, element, selected }: Props) {
  const { t } = useTranslation();

  return (
    <AbstractWarningItem
      warning={warning}
      element={element}
      selected={selected}
      title={t('editor-warning-text-overflow')}
    >
      {t('editor-warning-text-overflow-explanation')}
    </AbstractWarningItem>
  );
}

export default React.memo(TextOverflowWarningItem);
